export const ADOBE_FONT_FAMILIES = [
  {
    name: "Source Sans Pro",
    fontName: "'source-sans-pro', sans-serif",
  },
  {
    name: "Roboto",
    fontName: "'roboto', sans-serif",
  },
  {
    name: "Open Sans",
    fontName: "'open-sans', sans-serif",
  },
  {
    name: "Lato",
    fontName: "'lato', sans-serif",
  },
  {
    name: "Montserrat",
    fontName: "'montserrat', sans-serif",
  },
  {
    name: "Jacquard 24",
    fontName: "'jacquard-24', sans-serif",
  },
  {
    name: "Alexandria",
    fontName: "'alexandria', sans-serif",
  },
  {
    name: "Tiro Gurmukhi",
    fontName: "'tiro-gurmukhi', sans-serif",
  },
  {
    name: "Tiro Kannada",
    fontName: "'tiro-kannada', sans-serif",
  },
  {
    name: "Dejavu Sans",
    fontName: "'dejavu-sans', sans-serif",
  },
  {
    name: "Poppins",
    fontName: "'poppins', sans-serif",
  },
  {
    name: "Merriweather",
    fontName: "'merriweather', sans-serif",
  },
  {
    name: "Playfair Display",
    fontName: "'playfair-display', sans-serif",
  },
  {
    name: "Nunito",
    fontName: "'nunito', sans-serif",
  },
  {
    name: "Ubuntu",
    fontName: "'ubuntu', sans-serif",
  },
  {
    name: "Oswald",
    fontName: "'oswald', sans-serif",
  },
  {
    name: "PT Sans",
    fontName: "'pt-sans', sans-serif",
  },
  {
    name: "Work Sans",
    fontName: "'work-sans', sans-serif",
  },
  {
    name: "Rubik",
    fontName: "'rubik', sans-serif",
  },
  {
    name: "Lora",
    fontName: "'lora', serif",
  },
  {
    name: "Arvo",
    fontName: "'arvo', serif",
  },
  {
    name: "Fira Sans",
    fontName: "'fira-sans', sans-serif",
  },
 
  {
    name: "Bebas Neue",
    fontName: "'bebas-neue', sans-serif",
  },
];
